import React, { Component } from 'react';
import firebase from 'firebase';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './App.scss';
import Login from './screens/login/Login';
import Home from './screens/home/Home';
import Version from './components/Version';
import env from './globals/environment';
import { getAuthStatus } from './actions/AuthActions';

class App extends Component {
  UNSAFE_componentWillMount() {
    firebase.initializeApp(env.firebaseConfig);
    this.props.getAuthStatus();
  }

  renderRoot() {
    if (!this.props.loaded) return null;
    if (this.props.signedIn) return <Home />;
    return <Login />;
  }

  render() {
    return (
      <div className="containerFullWidth" style={{ display: 'flex', flex: 1 }}>
        {this.renderRoot()}
        <Version />
      </div>
    );
  }
}

const mapStateToProps = ({ authStore }) => {
  const { loaded, signedIn } = authStore;

  return { loaded, signedIn };
};

export default withRouter(connect(mapStateToProps, { getAuthStatus })(App));



// WEBPACK FOOTER //
// ./src/App.js